import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from 'react-redux';

import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";

import { contractCall, getAllbaroData } from "../../crud/auth.crud"
import Pagination from "pages/Custom/Pagination";
import Loading from "pages/Custom/Loading";

const AllbaroProcess = () => {
  const selector = useSelector(state => state);

  const [page, setPage] = useState(1)
  const [dataList, setDataList] = useState([])
  const [onUpload, setOnUpload] = useState(false);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [totalDataCount, setTotalDataCount] = useState(0)

  const getDataList = async () => {
    setOnUpload(true)

    const params = {
      page: page,
      company: companyId
    }

    const response = await getAllbaroData(params);
    setTotalDataCount(response.data.count || 0)
    if (response.status === 200) {
      const content = response.data?.results || [];
      setDataList(content)
      if (content.length === 0) {
        setIsListEnd(true)
      }
    }
    setOnUpload(false)
  }

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <React.Fragment>
      <Row>
        <Col md={12} lg={9} xl={6}>
          <div className="email-rightbar mb-3">
            <Card>
              <div className="radius-4 overflow-hidden">
                <div className="table-responsive">
                  <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                    <thead className="chart-thead">
                      <tr>
                        <th scope="col" style={{ fontWeight: 600 }}>ID</th>
                        <th scope="col" style={{ fontWeight: 600 }}>거래처명</th>
                        <th scope="col" style={{ fontWeight: 600 }}>거래일자</th>
                        <th scope="col" style={{ fontWeight: 600 }}>차량번호</th>
                        <th scope="col" style={{ fontWeight: 600 }}>입고량(kg)</th>
                      </tr>
                    </thead>
                    <tbody className="chart-tbody">

                      {
                        dataList && dataList.map((item, index) => {
                          return (
                            <tr key={item.id + '_' + index}>
                              <td>{item.id}</td>
                              <td>{item.company_to?.name}</td>
                              <td>{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}</td>
                              <td>{item.car_number}</td>
                              <td>{item.qty}</td>
                            </tr>
                          )
                        })
                      }
                      {!dataList &&
                        <tr >
                          <td scope="row" colSpan="6">데이터가 없습니다.</td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </div>
            </Card>

        <Pagination totalDataCount={totalDataCount} isLoading={onUpload} />

          </div>
        </Col>
        {onUpload && <Loading />}
      </Row>
    </React.Fragment>
  )
}

export default AllbaroProcess
